export default "__VITE_ASSET__4b18eccd__"